import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, List, ListItem, ListItemText, Divider, Chip, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import moment from 'moment';
import CaptionedField from '../../UIComponents/captionedField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
    },
    listItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    date: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
    },
    user: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    roles: {
        color: theme.palette.text.secondary,
        fontSize: '0.75rem',
    },
}));

const AuditLogHistory = ({ auditLogMeta = [], defaultExpanded = false }) => {
    const classes = useStyles();

    if (!auditLogMeta || auditLogMeta.length === 0) {
        return null;
    }

    return (

                <ExpansionPanel defaultExpanded={defaultExpanded}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="audit-log-content"
                        id="audit-log-header"
                    >
                        <Typography>View Audit Logs</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <List>
                            {auditLogMeta.map((log, index) => (
                                <React.Fragment key={index}>
                                    <ListItem className={classes.listItem}>
                                        <Chip label={log.type} color={log.type === 'approved' ? 'success' : 'primary'} />
                                        <ListItemText
                                            primary={
                                                <>
                                                <spna>By</spna>
                                                    <span className={classes.user}>{log.user}</span>
                                                    {' - '}
                                                    {log.description}
                                                </>
                                            }
                                            secondary={
                                                <>
                                                    <Typography component="span" className={classes.date}>
                                                        {moment(log.date).format('MMMM D, YYYY h:mm A')}
                                                    </Typography>
                                                    <br />
                                                </>
                                            }
                                        />
                                        <CaptionedField  style='text' value={log.payrollId} label='PayrollID' />
                                    
                                               <CaptionedField value={log.net} label='Net' />
                                          
                                    </ListItem>
                                    {index < auditLogMeta.length - 1 && <Divider />}
                                </React.Fragment>
                            ))}
                        </List>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

    );
};

export default AuditLogHistory; 